<template>
	<div class="login-wrapper">
		
		<h2 class="title">重置密码</h2>
		<el-form :model="form" ref="form" :rules="rules" class="form">
			<el-form-item prop="account">
			    <el-input v-model="form.mobile" placeholder="请输入手机号"></el-input>
			</el-form-item>
			<el-form-item prop="code">
			    <div class="getcode">
			    	<el-input v-model="form.code" placeholder="请输入验证码"></el-input>
			    	<el-button type="warning" class="code-btn" @click="getCode" :disabled="buttonDisable">{{buttonName}}</el-button>
			    </div>
			</el-form-item>
			<el-form-item prop="newPassword">
			    <el-input v-model="form.newPassword" placeholder="请输入新密码" show-password></el-input>
			</el-form-item>
			<el-form-item prop="confirmPass">
			    <el-input v-model="form.confirmPass" placeholder="请确认密码" show-password></el-input>
			</el-form-item>
			
		</el-form>

		<el-button type="warning" class="submit-btn" @click="submitForm">提交</el-button>
		
	</div>
</template>

<script>
import { login,forgotPassword,passCode  } from '@/api/login/login'
var index;
export default {
  data () {
	  var validateNewPass = (rule, value, callback) => {
	    if (value !== this.form.newPassword) {
	       callback(new Error('两次输入密码不一致!'));
	    } else {
	      callback()
	    }
	  }
    return {
      form:{
		  mobile: '',
		  code: '',
		  newPassword: '',
		  confirmPass: '',
	  },
	  logintype: 1,
	  buttonName: '获取验证码',
	  buttonDisable: false,
	  timeNum: 59,
	  rules: {
	  	account:  [{ required:true, message: '请输入手机号',trigger: 'blur'}],
		code: [{ required:true, message: '请输入验证码',trigger: 'blur'}],
	  	newPassword: [{ required:true, message: '请输入新密码',trigger: 'blur'},
	  		{ min: 6, message: '密码长度不低于6位',trigger: 'blur'}],
	  	confirmPass:[{ required:true, message: '请再次填写确认',trigger: 'blur'},
	  		{ validator: validateNewPass,trigger: 'blur'}]
	  }
    }
  },
  methods: {
    submitForm(){
		this.$refs.form.validate(async (valid) => {
		  if (valid) {
			const res = await register({
			  newPassword: this.form.newPassword,
			  mobile: this.form.mobile,
			  verfCode: this.form.code
			})
			if (res.code === 0) {
				this.$message.success('密码修改成功')
				this.$router.push({path:'/login'})
			} else {
			  this.$message.error(res.msg)
			}
		  } else {
			console.log('error submit!!');
			return false;
		  }
		});
	
	},
	async getCode(){
		this.buttonName = this.timeNum+'s后重新获取'
		this.buttonDisable = true;
		index = setInterval(()=>{ 
			this.timeNum--;		
			this.buttonName = this.timeNum+'s后重新获取';
			
		},1000)
		const res = await passCode({mobile:this.form.mobile})
		if (res.code === 0) {
			this.$message.success('验证码发送成功')
		} else {
		  this.$message.error(res.msg)
		}
	}
  },
  watch:{
	 timeNum(newval){
		 if(newval==0){
		 	this.buttonName = '获取验证码';
		 	this.buttonDisable = false;
		 	clearInterval(index);
			this.timeNum = 59;
		 }
	 } 
  },
  mounted () {
    
  },
  destroyed(){
  	  clearInterval(index)
  }
}
</script>

<style lang="scss" scoped>
.login-wrapper{
	background-color: #fff;
	border-radius: 20px;
	width: 20vw;
	min-width: 280px;
	padding: 30px 30px 50px;
	text-align: center;
	.title{
		margin: 10px 0 40px;
	}
	.form{
		margin-bottom: 20px;
		.getcode{
			position: relative;
			.code-btn{
				position: absolute;
				bottom: 0;
				right: 0;
				background-color: #FF842E;
			}
		}
		/deep/.el-input.is-active .el-input__inner,
		/deep/.el-input__inner:focus{
			border-color: #C0C4CC;
		}
	}
	.el-form-item{
		margin-bottom: 15px;
	}
	.el-form-item__error{
		padding-top: 1px;
	}
	.submit-btn{
		width: 100%;
		background-color: #FF842E;
	}
	
}
</style>